import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { LINKS } from "@constants";
import { Button } from "../../../components/shared/actions";
import { BannerContents } from "../../../components/shared/layout";
import imagensPrevidencia from "@asserts/images/previdencia/index";
import GenericBanner from "../../../components/blocosCustomizados/GenericBanner";
import GuiaButton from "../../../components/shared/actions/GuiaButton";

export const BannersPrestamista = (props) => {
  const { images } = props;

  return (
    <>
      <BannerContents {...props}>
        <BannerContents.Banner
          backgroundImage={images.bannerPrestamista}
          className="text-white"
          right
        >
          <Row>
            <Col xs={12} className="d-flex align-items-stretch">
              <FaFileInvoiceDollar className="d-none d-md-inline-block cvp-icon-banner" />
              <h3 className="d-md-inline-block">Seguro Dívida Zero</h3>
            </Col>
            <Col xs={12}>
              <p className="text-body-md">
                Garanta o pagamento do seu empréstimo junto à CAIXA em caso de
                morte ou invalidez total
              </p>
              <Button className="mt-3" blank secondary href={LINKS.areaLogada}>
                Já sou cliente
              </Button>
            </Col>
          </Row>
        </BannerContents.Banner>
        <GenericBanner
          image={imagensPrevidencia.bannerAssistenciaProtecao}
          text={
            <>
              <div className="margin-top-ajustada">
                <h4 style={{ color: "#F39200", fontSize: "1.6rem" }}>
                  ASSISTÊNCIAS QUE VÃO
                  <br />
                  ALÉM DA PROTEÇÃO
                </h4>
                <p>
                  Com os nossos Seguros de Vida e planos de Previdência, você
                  conta com assistências exclusivas que facilitam seu dia a dia
                  e garantem tranquilidade nos momentos em que mais precisa.
                </p>
                <h4>Conheça os serviços disponíveis.</h4>
              </div>
              <div style={{ marginTop: "32px" }}>
                <GuiaButton href={LINKS.guiaAssistencias2025}>
                  BAIXE O GUIA
                </GuiaButton>
              </div>
            </>
          }
          textClassName="text-assistencias"
        />
      </BannerContents>
    </>
  );
};

BannersPrestamista.defaultProps = { images: {} };

BannersPrestamista.propTypes = {
  images: PropTypes.objectOf(Object)
};

export default BannersPrestamista;
